var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 px-5 error lighten-2 rounded-lg mb-4 body-2"},[_vm._v(" "+_vm._s(_vm.$t('Company settings edit is disabled by owner'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }